// declare var Pusher: any;

import { Injectable } from '@angular/core';
import Pusher from 'pusher-js';
import Echo from "laravel-echo";

import { environment } from "@teem/environments/environment";

(window as any).Pusher = Pusher;

@Injectable({
  providedIn: 'root'
})
export class EchoService {
  public echo: any = null;

  constructor() {
    // this.echo = new Echo({
    //   broadcaster: 'pusher',
    //   key: environment.pusher_key,
    //   cluster: 'mt1',
    //   wsHost: window.location.hostname,
    //   wsPort: 6001,
    //   wssPort: 6001,
    //   disabledStats: true,
    //   enabledTransports: ['ws', 'wss']
    // });

    console.log('here in echo');

    this.echo = new Echo({
      broadcaster: 'pusher',
      key: environment.pusher_key,
      cluster: 'mt1',
      wsHost: window.location.hostname,
      wsPort: 6001,
      disabledStats: true,
      forceTLS: false,
      enabledTransports: ['ws']
    });

    // this.echo = new Echo({
    //   auth:{ headers: { 'Authorization': 'Bearer ' + user.token } },
    //   broadcaster: 'pusher',
    //   key: environment.pusher_key,
    //   cluster: 'mt1',
    //   wsHost: window.location.hostname,
    //   wsPort: 6001,
    //   wssPort: 6001,
    //   disabledStats: false,
    //   enabledTransports: ['ws', 'wss']
    // });
  }

  getEcho() {
    return this.echo;
  }
}
